import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { TtAtlas } from "../TobaccoTourAssets"

export class ActivityBackground {
    sprite: Phaser.Sprite

    private start = "start"
    private end = "end"

    constructor(
        private game: Phaser.Game,
        group: Phaser.Group,
        background: string = TtAtlas.MOVIE_BACKGROUND,
    ) {
        this.sprite = Sprites.add(this.game, background, {
            group,
            x: Scale.x(0.234),
            y: Scale.y(0.207),
        })
        Sprites.centerInWorldXOnly(this.sprite)
        this.sprite.animations.add(this.start, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9])
        this.sprite.animations.add(this.end, [11, 12, 13, 14, 15, 16, 17, 18])
    }

    open = (onComplete: () => void) => {
        this.sprite.animations.play(this.start, 30, false)
        if (onComplete) {
            this.sprite.events.onAnimationComplete.addOnce(onComplete)
        }
    }

    close = () => {
        this.sprite.animations.play(this.end, 30, false)
        this.sprite.events.onAnimationComplete.addOnce(() =>
            this.sprite.destroy(),
        )
    }
}
